import { buildMap } from '@/views/map';
import { initStorages, initPhotos } from '../pages-root';
import { initExpandableList } from '../pages-personal_business_storage';
import { isMobile } from '@/helpers/mobile_detect';

let map = null;
let storagesSwiper = null;
let photosSwiper = null;
let itemsSwiper = null;

pageUnload('info_pages_show', () => {
  if (map) {
    map.destroy();
    map = null;
  }

  if (storagesSwiper) {
    storagesSwiper.destroy();
    storagesSwiper = null;
  }
  if (photosSwiper) {
    photosSwiper.destroy();
    photosSwiper = null;
  }
  if (itemsSwiper) {
    itemsSwiper.destroy();
    itemsSwiper = null;
  }
});

pageLoad('info_pages_show', async () => {
  photosSwiper = initPhotos();
  initExpandableList();

  if (isMobile()) {
    storagesSwiper = initStorages();
    const { default: Swiper } = await import('swiper');

    itemsSwiper = new Swiper('.swiper-v8', {
      wrapperClass: 'related-info_pages-wrapper',
      slideClass: 'b-related-info_page',
      grabCursor: true,
      // slidesPerView: 1,
      slidesPerView: 'auto',
      spaceBetween: 24
    });
  } else {
    const $map = $('#map_desktop');
    if ($('#map_desktop').length) {
      map = (await buildMap({
        node: $map[0],
        isAutoCenter: false,
        leadProps: $map.data('lead-props')
      })).map;
    }
  }
});
